// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-value-wrapper {
  margin-right: 10px;
  margin-bottom: 16px;
}
.layout-1 {
  width: 100%;
}
.layout-2 {
  width: calc(50% - 10px);
}
.layout-3 {
  width: calc(33% - 10px);
}
.layout-4 {
  width: calc(25% - 10px);
}
.layout-5 {
  width: calc(20% - 10px);
}
.label-value-wrapper .field-label {
  color: #222222;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 12px;
}
.label-value-wrapper input[type="text"],
.label-value-wrapper input[type="email"],
.label-value-wrapper input[type="date"],
.label-value-wrapper input[type="month"],
.label-value-wrapper input[type="number"] {
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  background: transparent;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  color: #1984bc;
  padding: 0 15px;
  outline: none;
  width: 100%;
}
.label-value-wrapper input[type="text"]:focus,
.label-value-wrapper input[type="email"]:focus,
.label-value-wrapper input[type="date"]:focus,
.label-value-wrapper input[type="month"]:focus,
.label-value-wrapper input[type="number"]:focus,
.label-value-wrapper input[type="checkbox"]:focus,
.label-value-wrapper select:focus {
  border: 1px solid #222;
}
.label-value-wrapper input[type="text"]:disabled {
  background: #f1f4f6;
  border: 1px solid #d6d6d6;
}
.label-value-wrapper input[type="date"]:disabled {
  background: #f1f4f6;
  border: 1px solid #d6d6d6;
}
.label-value-wrapper select[disabled] {
  background: #f1f4f6;
  border: 1px solid #d6d6d6;
}
.label-value-wrapper input[type="number"]:disabled {
  background: #f1f4f6;
  border: 1px solid #d6d6d6;
}
.label-value-wrapper input[type="checkbox"] {
  margin-right: 13px;
}
.label-value-wrapper select {
  width: 100%;
  height: 44px;
  line-height: 44px;
  padding: 0 15px;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  background: transparent;
  font-size: 14px;
  color: #1984bc;
  outline: none;
}
.label-value-wrapper option {
  color: #1984bc;
}
.label-value-wrapper input[type="date"] {
  text-transform: uppercase;
}
.checkbox-label {
  font-size: 14px;
}
.label-value-wrapper textarea {
  width: 100%;
  height: 64px;
  padding: 10px;
  outline: none;
  border-radius: 6px;
  max-height: 64px;
  border: 1px solid #d6d6d6;
  font-size: 14px;
  color: #1984bc;
}
.label-value-wrapper textarea:disabled {
  background: #f1f4f6;
  border: 1px solid #d6d6d6;
}
textarea {
  max-width: 100%;

  resize: none;
}
.label-value-wrapper input[type="date"]::-webkit-scrollbar {
  display: none !important;
}
.label-value-wrapper input.error-border {
  border: 1px solid #d93025;
}
.no-margin-text-field > .label-value-wrapper {
  margin-right: 0px;
  margin-bottom: 0px;
}
.hide-label {
  display: none;
}
.errorMessage {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  color: #d93025;
  margin-top: 2px;
  font-size: 11px;
  display: inline-block;
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
/* .highlightUnfilledFields .label-value-wrapper.value--empty label {
  color: #e0a633;
} */
.highlightUnfilledFields .label-value-wrapper.value--empty input[type="text"],
.highlightUnfilledFields .label-value-wrapper.value--empty input[type="email"],
.highlightUnfilledFields .label-value-wrapper.value--empty input[type="number"],
.highlightUnfilledFields .label-value-wrapper.value--empty input[type="date"],
.highlightUnfilledFields .label-value-wrapper.value--empty input[type="month"],
.highlightUnfilledFields .label-value-wrapper.value--empty textarea,
.highlightUnfilledFields .label-value-wrapper.value--empty select {
  border-color: #e0a633;
}
.label-value-wrapper option {
  color: #1984bc;
}
.label-value-wrapper select {
  color: #1984bc;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/formField/FormField.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;;EAKE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,WAAW;AACb;AACA;;;;;;;EAOE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;;EAEf,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EAEE,gEAAgE;EAChE,wBAAwB;EAExB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;AAoBA;EACE;;IAEE,kCAAkC;EACpC;EACA;;IAEE,iCAAiC;EACnC;EACA;;;IAGE,kCAAkC;EACpC;EACA;;IAEE,iCAAiC;EACnC;AACF;AACA;;GAEG;AACH;;;;;;;EAOE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":[".label-value-wrapper {\n  margin-right: 10px;\n  margin-bottom: 16px;\n}\n.layout-1 {\n  width: 100%;\n}\n.layout-2 {\n  width: calc(50% - 10px);\n}\n.layout-3 {\n  width: calc(33% - 10px);\n}\n.layout-4 {\n  width: calc(25% - 10px);\n}\n.layout-5 {\n  width: calc(20% - 10px);\n}\n.label-value-wrapper .field-label {\n  color: #222222;\n  margin-bottom: 5px;\n  font-weight: 600;\n  font-size: 12px;\n}\n.label-value-wrapper input[type=\"text\"],\n.label-value-wrapper input[type=\"email\"],\n.label-value-wrapper input[type=\"date\"],\n.label-value-wrapper input[type=\"month\"],\n.label-value-wrapper input[type=\"number\"] {\n  border: 1px solid #d6d6d6;\n  border-radius: 6px;\n  background: transparent;\n  height: 44px;\n  line-height: 44px;\n  font-size: 14px;\n  color: #1984bc;\n  padding: 0 15px;\n  outline: none;\n  width: 100%;\n}\n.label-value-wrapper input[type=\"text\"]:focus,\n.label-value-wrapper input[type=\"email\"]:focus,\n.label-value-wrapper input[type=\"date\"]:focus,\n.label-value-wrapper input[type=\"month\"]:focus,\n.label-value-wrapper input[type=\"number\"]:focus,\n.label-value-wrapper input[type=\"checkbox\"]:focus,\n.label-value-wrapper select:focus {\n  border: 1px solid #222;\n}\n.label-value-wrapper input[type=\"text\"]:disabled {\n  background: #f1f4f6;\n  border: 1px solid #d6d6d6;\n}\n.label-value-wrapper input[type=\"date\"]:disabled {\n  background: #f1f4f6;\n  border: 1px solid #d6d6d6;\n}\n.label-value-wrapper select[disabled] {\n  background: #f1f4f6;\n  border: 1px solid #d6d6d6;\n}\n.label-value-wrapper input[type=\"number\"]:disabled {\n  background: #f1f4f6;\n  border: 1px solid #d6d6d6;\n}\n.label-value-wrapper input[type=\"checkbox\"] {\n  margin-right: 13px;\n}\n.label-value-wrapper select {\n  width: 100%;\n  height: 44px;\n  line-height: 44px;\n  padding: 0 15px;\n  border: 1px solid #d6d6d6;\n  border-radius: 6px;\n  background: transparent;\n  font-size: 14px;\n  color: #1984bc;\n  outline: none;\n}\n.label-value-wrapper option {\n  color: #1984bc;\n}\n.label-value-wrapper input[type=\"date\"] {\n  text-transform: uppercase;\n}\n.checkbox-label {\n  font-size: 14px;\n}\n.label-value-wrapper textarea {\n  width: 100%;\n  height: 64px;\n  padding: 10px;\n  outline: none;\n  border-radius: 6px;\n  max-height: 64px;\n  border: 1px solid #d6d6d6;\n  font-size: 14px;\n  color: #1984bc;\n}\n.label-value-wrapper textarea:disabled {\n  background: #f1f4f6;\n  border: 1px solid #d6d6d6;\n}\ntextarea {\n  max-width: 100%;\n\n  resize: none;\n}\n.label-value-wrapper input[type=\"date\"]::-webkit-scrollbar {\n  display: none !important;\n}\n.label-value-wrapper input.error-border {\n  border: 1px solid #d93025;\n}\n.no-margin-text-field > .label-value-wrapper {\n  margin-right: 0px;\n  margin-bottom: 0px;\n}\n.hide-label {\n  display: none;\n}\n.errorMessage {\n  -webkit-animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  perspective: 1000px;\n  color: #d93025;\n  margin-top: 2px;\n  font-size: 11px;\n  display: inline-block;\n}\n@-webkit-keyframes shake {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n@keyframes shake {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n/* .highlightUnfilledFields .label-value-wrapper.value--empty label {\n  color: #e0a633;\n} */\n.highlightUnfilledFields .label-value-wrapper.value--empty input[type=\"text\"],\n.highlightUnfilledFields .label-value-wrapper.value--empty input[type=\"email\"],\n.highlightUnfilledFields .label-value-wrapper.value--empty input[type=\"number\"],\n.highlightUnfilledFields .label-value-wrapper.value--empty input[type=\"date\"],\n.highlightUnfilledFields .label-value-wrapper.value--empty input[type=\"month\"],\n.highlightUnfilledFields .label-value-wrapper.value--empty textarea,\n.highlightUnfilledFields .label-value-wrapper.value--empty select {\n  border-color: #e0a633;\n}\n.label-value-wrapper option {\n  color: #1984bc;\n}\n.label-value-wrapper select {\n  color: #1984bc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
